/**
 * Application kind, shown as a badge and editable in the application's settings.
 * `web` is the default for every application. `mcp` additionally marks an MCP
 * server registered as its own application; the other kinds behave like `web`.
 * Source of the `property_type` Postgres enum (keep the existing order).
 */
export const APPLICATION_TYPES = ['web', 'api', 'mcp', 'cli'] as const;

export type ApplicationType = (typeof APPLICATION_TYPES)[number];

/** Display labels for each application type. */
export const APPLICATION_TYPE_LABELS: Record<ApplicationType, string> = {
  web: 'Web',
  mcp: 'MCP',
  api: 'API',
  cli: 'CLI',
};

export function isApplicationType(value: string): value is ApplicationType {
  return (APPLICATION_TYPES as readonly string[]).includes(value);
}
